export default __webpack_public_path__ + "static/media/faq-ellipse-right.0df9309b.svg";